import { useState, useEffect } from "react";
import { useGoogleOneTapLogin } from "@react-oauth/google";

const _GOOGLE_CLIENT_ID =
  "871603704767-18enjm7ns128g4tebu1jltmlj8i66v06.apps.googleusercontent.com";
const AUTH_API="/api/user/auth/google";

export default function useAuth({ onLoginSuccess, onCloseModals } = {}) {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  // Check for existing auth on mount
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const token = localStorage.getItem("fm_token");
    if (token) {
      fetch("/api/user/profile", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((r) => {
          if (!r.ok) throw new Error("Token invalid");
          return r.json();
        })
        .then((data) => {
          setUser(data.user);
          setIsAdmin(data.is_admin || false);
          // Restore liked/favorited library on page refresh
          if (onLoginSuccess) onLoginSuccess({ token });
        })
        .catch(() => {
          localStorage.removeItem("fm_token");
        });
    }
  }, []);

  // Credential response handler — shared by One Tap and GoogleLogin button
  async function handleCredentialResponse(response) {
    setAuthLoading(true);
    try {
      const res = await fetch(AUTH_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ credential: response.credential }),
      });
      if (!res.ok) {
        const errText = await res.text();
        throw new Error(errText || "auth failed");
      }
      const data = await res.json();
      localStorage.setItem("fm_token", data.token);
      setUser(data.user);
      setIsAdmin(data.is_admin || false);
      setAuthLoading(false);
      if (onLoginSuccess) onLoginSuccess(data);
      if (onCloseModals) onCloseModals();
    } catch (err) {
      console.error("Google login error:", err);
      setAuthLoading(false);
    }
  }

  // One Tap — only prompt if not logged in
  useGoogleOneTapLogin({
    onSuccess: handleCredentialResponse,
    onError: () => console.error("One Tap error"),
    disabled: !!user,
  });

  const logout = () => {
    localStorage.removeItem("fm_token");
    setUser(null);
    setIsAdmin(false);
  };

  const userInitials = user?.name
    ? user.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "?";

  /**
   * Called by EmailLoginModal after successful email-code verification.
   * Sets user + isAdmin states and triggers the onLoginSuccess callback.
   */
  function updateAuthFromEmail(data) {
    localStorage.setItem("fm_token", data.token);
    setUser(data.user);
    setIsAdmin(data.is_admin || false);
    if (onLoginSuccess) onLoginSuccess(data);
    if (onCloseModals) onCloseModals();
  }

  return { user, authLoading, logout, isAdmin, userInitials, updateAuthFromEmail, handleCredentialResponse };
}
